import { Box } from "@mui/material";
import styled from "styled-components";

export const PinVerificationStyled = styled(Box)`
  .confirm-input-fields {
    display: flex !important;
    justify-content: center;
    gap: 16px !important;

    & input {
      height: 58px;
      width: 58px;
      text-align: center;
      outline: none;
      font-size: 20px;
      border: 1px solid #b9bec7;
      background-color: #fff;
      border: 2px solid #2460b8;
      border-radius: 20px;
    }

    & input:nth-child(3)::after {
      content: "-";
      display: inline-block;
      position: absolute;
      transform: translate(10px, 10px);
      font-size: 20px;
      color: #000;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    @media (max-width: 500px) {
      gap: 6px !important;

      & input {
        height: 40px;
        width: 40px;
        font-size: 16px;
        border-radius: 15px;
      }
    }
  }

  .resend-timer {
    margin-top: 10px;
    font-size: 14px;
    font-weight: bold;

    @media (max-width: 1024px) {
      /* Tablet view */
      font-size: 13px;
    }

    @media (max-width: 768px) {
      /* Mobile view */
      font-size: 12px;
    }
  }
`;
